// extracted by mini-css-extract-plugin
module.exports = {"set-test-phenotype":"SetTestPhenotype_set-test-phenotype__2VrWh"};